// extracted by mini-css-extract-plugin
export default {"box":"popupFollowAlert_box__XJhdj","portfolioList":"popupFollowAlert_portfolioList__l-z4w"};